import type { LineItem } from "@commercetools/platform-sdk";
import { type EcommerceItem, getEcommerceItem } from "../use-gtm-variables";

interface AddToCartCheckoutEventData {
	ecommerce: {
		currencyCode: string;
		add: {
			products: EcommerceItem[];
		};
	};
}

export const getData = (lineItems: LineItem[]): AddToCartCheckoutEventData => {
	return {
		ecommerce: {
			currencyCode: lineItems[0]?.price.value.currencyCode || "",
			add: {
				products: lineItems.map((lineItem) => getEcommerceItem(lineItem)),
			},
		},
	};
};
